var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "tab",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
        },
        scopedSlots: _vm._u([
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "colJumpUrl",
            fn: function ({ row }) {
              return [
                row.jump_url
                  ? _c(
                      "el-link",
                      {
                        attrs: {
                          type: "primary",
                          href: row.jump_url,
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(row.jump_url))]
                    )
                  : _c("span", [_vm._v("无")]),
              ]
            },
          },
          {
            key: "colImageUrl",
            fn: function ({ row }) {
              return [
                row.image_url
                  ? _c("el-image", {
                      staticStyle: {
                        width: "80px",
                        height: "40px",
                        cursor: "pointer",
                      },
                      attrs: {
                        src: row.image_url,
                        "preview-src-list": [row.image_url],
                        fit: "cover",
                      },
                    })
                  : _c("span", [_vm._v("无")]),
              ]
            },
          },
          {
            key: "colDisplayTime",
            fn: function ({ row }) {
              return [
                row.end_at === -1
                  ? _c("span", [_vm._v("永久有效")])
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          row.start_at ? _vm.parseTime(row.start_at) : ""
                        ) +
                          " 至 " +
                          _vm._s(row.end_at ? _vm.parseTime(row.end_at) : "")
                      ),
                    ]),
              ]
            },
          },
          {
            key: "colStatus",
            fn: function ({ row }) {
              return [
                row.status === "enabled"
                  ? _c(
                      "el-tag",
                      { attrs: { size: "small", type: "success" } },
                      [_vm._v("启用")]
                    )
                  : row.status === "disabled"
                  ? _c("el-tag", { attrs: { size: "small" } }, [_vm._v("停用")])
                  : _c("span", [_vm._v(_vm._s(row.status))]),
              ]
            },
          },
          {
            key: "colUpdatedAt",
            fn: function ({ row }) {
              return [
                row.updated_at
                  ? _c("span", [_vm._v(_vm._s(_vm.parseTime(row.updated_at)))])
                  : _c("span", [_vm._v("无")]),
              ]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.handleEdit(row)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
                _c(
                  "el-button",
                  {
                    class:
                      row.status === "disabled"
                        ? "success-button"
                        : "info-button",
                    attrs: { size: "small", type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.handleToggleStatus(
                          row,
                          row.status === "disabled" ? "enabled" : "disabled"
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(row.status === "disabled" ? "启用" : "停用") +
                        " "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "danger-button",
                    attrs: { size: "small", type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.handleDelete(row)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ]
            },
          },
        ]),
      }),
      _c("ManageCarouselAdDialog", {
        attrs: {
          visible: _vm.dialogVisible,
          "dialog-title": _vm.dialogTitle,
          "form-data": _vm.formData,
          "dialog-loading": _vm.dialogLoading,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          success: _vm.handleDialogSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }